import {
  BlockControls,
  useInnerBlocksProps,
  useBlockProps,
  InspectorControls,
} from '@wordpress/block-editor';

import { useEffect, useRef, useState } from '@wordpress/element';
import { getScreens } from 'blockbite-tailwind';
import CarouselControls from './CarouselControls';
import useUpdateSwiper from './useUpdateSwiper.ts';

export default function Edit(props) {
  const swiperRef = useRef(null);
  const { attributes, clientId, contentType } = props;
  const { carouselSettings } = attributes;

  const blockProps = useBlockProps();

  const { children, ...innerBlocksProps } = useInnerBlocksProps({
    allowedBlocks:
      contentType === 'dynamic' ? ['core/query'] : ['blockbite/carousel-slide'],
  });

  useUpdateSwiper(props, swiperRef);

  return (
    <>
      <CarouselControls {...props} />
      <div {...blockProps} ref={swiperRef}>
        {/* Swiper Container */}
        <swiper-container init="false" {...innerBlocksProps}>
          {children}
        </swiper-container>
      </div>
    </>
  );
}
